import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormElementComponent } from '../form-element/form-element.component';

@Component({
    selector: 'app-switcheable-chip',
    templateUrl: './switcheable-chip.component.html',
    styleUrl: './switcheable-chip.component.scss'
})
export class SwitcheableChipComponent extends FormElementComponent implements OnInit {
    @Input() text: string = '';
    //this component has two types: ('close' => icon = X default   ) and ('add' => icon = + )
    @Input() active: boolean=false;
    @Input() override disabled!: boolean;
    @Input()loading: boolean = false;

    @Input() buttonClass: string = '';
    @Input() textClass: string = '';
    @Input() activeBgColor: string = '';
    @Input() inactiveBgColor: string = '';

     internalActive = false;

    @Output() change = new EventEmitter();

    constructor() {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['active']) {
          this.internalActive = this.active;
        }
      }

      onChange() {
        if (!this.disabled) {
          this.internalActive = !this.internalActive;
          this.change.emit(this.internalActive);
        }
      }

    getError() { }

    getBackgroundStyle(): { [key: string]: string } {
        return {
          'background-color': this.internalActive
            ? this.activeBgColor || 'var(--color-switcheable-chip-active-bg)'
            : this.inactiveBgColor || 'var(--color-white)',
          'opacity': this.disabled ? '0.5' : '1',
          'cursor': this.disabled ? 'default' : 'pointer'
        };
      }
      getCloseBtnBackgroundStyle(): { [key: string]: string } {
        return {
          'background-color': this.internalActive
            ? (this.activeBgColor || 'var(--color-switcheable-chip-control-bg)')
            : 'var(--color-grey-medium)',
        };
      }

      getTextColorStyle(): { [key: string]: string } {
        return {
          'color': this.internalActive ? 'var(--color-white)' : 'var(--color-grey-medium)'
        };
      }


}
